import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { Table, TableModule } from "primeng/table";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import * as FileSaver from "file-saver";
import { ActivatedRoute } from "@angular/router";
import { FreightChargesListDto } from "../../../../core/models/orders/freightChargesListDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CommonModule } from "@angular/common";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { FilterMetadata } from "primeng/api";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { ButtonModule } from "primeng/button";
import { FreightDetailsComponent } from "../../../bcledger/components/freight-details/freight-details.component";

@Component({
  selector: "jni-freight-charges",
  templateUrl: "./freight-charges.component.html",
  styleUrls: ["./freight-charges.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ModalStackerComponent,
    SpinnerComponent,
    ButtonModule,
    FreightDetailsComponent,
  ],
})
export class FreightChargesComponent implements OnInit, OnDestroy {
  @Input() saleOrderId = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeTrackingListModalEvent = new EventEmitter();
  @Input() isModal = false;
  totalAmount = 0;

  FreightChargesLists: FreightChargesListDto[] = [];
  filterFreightChargesLists: FreightChargesListDto[] = [];

  totalFreightCost!: number;
  totalFreightRetail!: number;
  totalFreightSell!: number;
  totalProcessingfees!: number;
  totalBilledCharge!: number;
  totalTaxCredit!: number;
  fileName = "FreightCharges";
  orderTrackingDisplayModal = false;
  trackingNumber = "";

  @ViewChild("dt") table!: Table;

  constructor(
    private _loaderService: LoaderService,
    private _orderSummaryService: OrderSummaryService,
    public _activatedRoute: ActivatedRoute,
    private _toastr: JniToastrService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.saleOrderId = params["id"];
    });
  }

  ngOnInit(): void {
    this.getFreightCharges();
  }

  clearTable(table: Table) {
    table.clear();
  }

  getFreightCharges() {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService.getFreightCharges(this.saleOrderId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.status.toLowerCase() != "success") {
          this._toastr.error(res.message, "Error");
        } else {
          this.FreightChargesLists = res.data;
          this.totalAmount = this.FreightChargesLists.reduce(
            (total, charge) => total + charge.chargesValue,
            0
          );
          this.filterFreightChargesLists = this.FreightChargesLists.filter(
            x => !x.chargesCode.includes("2.5% fee")
          );
          this.table.filters["chargesCode"] = [
            { value: "2.5% fee", matchMode: "notContains", operator: "and" },
          ];
        }
      },
      error: res => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(res.message, "Error");
      },
    });
  }

  exportExcelFile() {
    const filter = this.table?.filters["chargesCode"] as FilterMetadata[];
    if (filter[0]?.value) {
      this.exportExcelForFilterData(this.filterFreightChargesLists);
    } else {
      this.exportExcelForFilterData(this.FreightChargesLists);
    }
  }

  exportExcelForFilterData(filterclientlist: FreightChargesListDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Charges Code"]: datum.chargesCode,
        ["Description"]: datum.description,
        ["Amount"]: datum.chargesValue,
        ["Reference"]: datum.reference,
        ["Reference Project Id"]: datum.projectId,
        ["Number"]: datum.number,
        ["Freight Bill #"]: datum.freightBill,
        ["Tracking Number"]: datum.trackingNumber,
        ["Created by"]: datum.createdBy,
        ["Created Date"]: datum.createdDateTime,
        ["Modified by"]: datum.modifiedBy,
        ["Modified Date"]: datum.modifiedDateTime,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "FreightChargeReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  onTrackingNumberSelection(trackingNumber: string) {
    if (trackingNumber) {
      this.trackingNumber = trackingNumber;
      this.orderTrackingDisplayModal = true;
    }
  }

  closeModalFromOrderTracking() {
    this.orderTrackingDisplayModal = false;
  }

  closeTrackingListModal() {
    this.closeTrackingListModalEvent.emit();
  }
}
